import strings from '../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.dependency.name.label,
  validators: []
}

export const form = {
  formKey: "dependency",
  fields: [
    name
  ]
}
